/**
 * Created by Ramon Wenger on 27.06.18.
 * Copyright (c) 2018 Iterativ GmbH. All rights reserved.
 */
import { Component } from "@angular/core";
import { Store } from "@ngrx/store";
import * as reducers from "../reducers";
import { AcceptUpdate2019Action } from "../actions/authentication";

@Component({
    selector: 'hc-accept-terms-admin',
    template: `
        <div class="page accept-terms">
            <div class="page__header">
                <hc-simple-header></hc-simple-header>
            </div>
            <div class="page__content accept-terms__content">
                <p translate>Lieber Schuladministrator</p>
                <p translate>Im November 2019 wurden die Datenschutzbestimmungen für Helloclass angepasst. Um Helloclass weiterhin zu nutzen, musst du die neuen Bestimmungen akzeptieren. Mehr Informationen zu den Datenschutzbestimmungen findest du <a href="https://helloclass.zendesk.com/hc/de/articles/360010372339-Helloclass-Privacy-Policy">hier</a>.</p>
                <p translate>Falls du mit den neuen Datenschutzbestimmungen nicht einverstanden bist, kannst du und die von dir verwalteten Benutzer Helloclass in Zukunft nicht mehr verwenden. Dein Konto wird in diesem Fall automatisch im März 2020 gelöscht.</p>
                <p translate>Hier geht's zur gesamten <a href=\"/assets/documents/DE_HelloClass_Privacy_Policy.pdf\">Datenschutzerklärung</a></p>
                <div>
                    <button class="btn btn--blue" (click)="acceptTerms()" translate>Ich bin mit den neuen Datenschutzbestimmungen einverstanden</button>
                </div>
            </div>
        </div>
    `
})
export class AcceptTermsAdminPage {

    constructor(private store: Store<reducers.AppState>) {

    }

    acceptTerms() {
        // mark notifiy message as read, maybe do in backend with job
        this.store.dispatch(new AcceptUpdate2019Action());
    }


}
